<template>
  <div class="right_col" role="main">
    <div class="row">
      <div class="col-md-12 col-sm-6 col-xs-12">
        <div class="title_left">
          <h3>編輯訊息</h3>
          <hr />
        </div>
      </div>
    </div>
    <div class="row option_item color_area" @click="setPicked(2)">
      <div class="col-md-2">
        <label for="new_message_radio" class="label-style">
          <input type="radio" name="messageType" value="2" v-model="picked" />
          傳給司機(全呼)
        </label>
      </div>
    </div>
    <div class="row option_item color_area" @click="setPicked(3)">
      <div class="col-md-2">
        <label for="new_message_radio" class="label-style">
          <input type="radio" name="messageType" value="3" v-model="picked" />
          傳給司機
        </label>
      </div>
      <div class="col-md-6 call_number_position">
        <input
          type="text"
          required="required"
          class="inputstyle col-md-5 fontSize14"
          placeholder="輸入呼號:022,025,023..."
          v-model="driver.callNumber"
          style="margin: 0px 5px"
        />
        <!--<button type="button" class="btn btn-success" @click="onSearchCallNumber" style="margin: 0px 5px">搜尋</button>-->
        <button
          type="button"
          class="btn btn-danger"
          @click="onClearCallNumber"
          style="margin: 0px 5px"
        >
          清空呼號
        </button>
      </div>
    </div>
    <div class="row subject">
      <div class="col-md-3 col-sm-3">
        <select
          id="heard"
          class="form-control"
          required=""
          v-model="messageItem"
          @change="selectDriverMessage(messageItem)"
        >
          <option
            :value="item"
            v-for="message in message_list"
            v-bind:value="message.message"
          >
            {{ message.message }}
          </option>
        </select>
      </div>
      <el-button type="primary" @click="showContent" :loading="isloading">
        確認送出
      </el-button>
    </div>
    <div class="row">
      <textarea
        id="message"
        rows="7"
        class="form-control textarea"
        placeholder="純文字...最多100個字"
        maxlength="200"
        v-model="content"
      ></textarea>
    </div>
  </div>
</template>
<script>
import API from '../../assets/js/libs/API'
import { cookies } from '@/utils/cookies'
import Message from '../../assets/js/libs/Message'
// import customers from '../../assets/js/cutomers.js'
var message = new Message()

export default {
  name: 'MessageEditor',
  data() {
    return {
      picked: 1,
      isSubject: true,
      driver: {
        callNumber: '',
      },
      drivermessage: {
        subject: '',
        message: '',
      },
      message_list: [],
      messageItem: '',
      customers: [],
      content: '',
      item: -1,
      isloading: false,
    }
  },
  mounted() {
    this.getDefaultMessage()
  },
  methods: {
    showContent() {
      // alert("此功能暫停使用，立即傳訊請到叫車紀錄")
      this.isloading = true
      switch (this.picked) {
        case 1:
          this.onInsertBtnClick()
          break
        case 2:
          this.onSendMessageToAllDriver()
          break
        case 3:
          this.onSendMessageToSingle()
          break
      }
    },
    onInsertBtnClick() {
      // console.log(cookies.get('GladName'))
      if (confirm('確定送出最新消息給所有司機嗎?')) {
        var data = {
          announcer: cookies.get('GladName'),
          subject: this.drivermessage.subject,
          content: this.content,
        }
        console.log(data)
        message
          .create(data)
          .then((res) => {
            this.isloading = false
            this.$router.replace({ name: 'MessageList' })
          })
          .catch((err) => {
            this.isloading = false
            if (err.data.error.type == 'unique') alert(err.data.error.message)
            else console.log(err)
            console.log(e)
          })
      }
    },
    onSendMessageToAllDriver() {
      let data = {
        announcer: cookies.get('GladName'),
        teamCode: cookies.get('GladTeamCode').toString(),
        content: this.content,
      }
      message
        .pushDriverMessage(data, 'all')
        .then((res) => {
          this.isloading = false
          if (res.success) {
            alert('傳送成功')
            this.content = ''
            this.item = -1
          } else {
            alert('傳送失敗，有可能呼號錯誤')
          }
        })
        .catch((err) => {
          this.isloading = false
          console.log(err)
          alert('傳送失敗，有可能呼號錯誤')
        })
    },
    onSendMessageToSingle() {
      let data = {
        announcer: cookies.get('GladName'),
        teamCode: cookies.get('GladTeamCode').toString(),
        content: this.content,
        callNumber: this.driver.callNumber,
      }
      // console.log(data)
      if (this.driver.callNumber === '') {
        alert('傳送失敗，有可能呼號錯誤')
      }
      // console.log(data)
      message
        .pushDriverMessage(data, 'one')
        .then((res) => {
          this.isloading = false
          if (res.success) {
            alert('傳送成功')
            this.content = ''
            this.driver.callNumber = ''
            this.item = -1
          } else {
            alert('傳送失敗，有可能呼號錯誤')
          }
        })
        .catch((err) => {
          this.isloading = false
          console.log(err)
          alert('傳送失敗，有可能呼號錯誤')
        })
    },
    setPicked(val) {
      this.picked = val
      switch (val) {
        case 2:
          this.isSubject = false
          break
        case 3:
          this.isSubject = false
          break
      }
    },
    onClearCallNumber() {
      this.driver.callNumber = ''
    },
    getDefaultMessage() {
      API.get(`defaultMessage`)
        .then((res) => {
          if (res.result === false) {
            this.message_list = []
            alert('找不到資訊')
            return
          }
          this.message_list = JSON.parse(res.result)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    selectDriverMessage(val) {
      // console.log(val)
      this.content = val
    },
  },
}
</script>
<style scoped>
.label-style {
  font-size: 16px;
  margin: 10px 20px;
}
.textarea {
  width: 95%;
  margin-top: 10px;
  font-size: 18px;
}
.mybtnstyle {
  margin-top: 20px;
  float: right;
  margin-right: 20px;
}
.color_area {
  background: #e6ecff;
  border-radius: 10px;
}
.option_item {
  margin-top: 10px;
}
.subject {
  margin-top: 35px;
}
.call_number_position {
  margin: 10px 0px 10px 0px;
}
</style>



// WEBPACK FOOTER //
// src/pages/message/MessageEditor.vue